export default __webpack_public_path__ + "static/media/videoPoster.953ed6b9.webp";